module.exports = __webpack_public_path__ + "static/img/zbbg.0c55e2c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/zbbg.png
// module id = F584
// module chunks = 0